"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../../shared"));

require("./UserNav.css");

var _UserNavItem = _interopRequireDefault(require("./UserNavItem"));

var _FormLabel = _interopRequireDefault(require("../../FormField/FormLabel"));

var _Radio = _interopRequireDefault(require("../../Radio/Radio"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
Sub-component to display list of products
*/
function UserNavProducts(_ref) {
  var className = _ref.className,
      Component = _ref.componentEl,
      children = _ref.children,
      products = _ref.products,
      product = _ref.product,
      onProductSwitch = _ref.onProductSwitch,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "componentEl", "children", "products", "product", "onProductSwitch"]);

  var cssClasses = ['st_usernav__item'];
  cssClasses = utils.classNames.addClassNames(className, cssClasses); // calls on the onProductSwitch prop when user clicks on a product
  // adding this so we can pass the value of the selected product
  // rather than a click event

  var localProductSwitch = (0, _react.useCallback)(function (e) {
    if (onProductSwitch) {
      if (e.target.checked) onProductSwitch(e.target.value);
    }
  }, [onProductSwitch]);
  return /*#__PURE__*/_react["default"].createElement(_UserNavItem["default"], null, /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), products.map(function (p) {
    return /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
      label: p.name,
      labelPosition: "right",
      fullWidth: true,
      key: p.value
    }, /*#__PURE__*/_react["default"].createElement(_Radio["default"], {
      name: "usernav_product",
      id: "usernav_product_" + p.value,
      onChange: localProductSwitch,
      value: p.value,
      checked: p.value === product
    }));
  })));
}

UserNavProducts.propTypes = {
  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** dom element or component to use for outermost wrapper */
  componentEl: utils.componentEl.props,

  /** products to display */
  products: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    value: _propTypes["default"].string,
    href: _propTypes["default"].string
  })).isRequired,

  /** current product name */
  product: _propTypes["default"].string,

  /** callback when user switches product */
  onProductSwitch: _propTypes["default"].func
};
UserNavProducts.defaultProps = {
  className: null,
  componentEl: 'div',
  onProductSwitch: null,
  product: null
};
UserNavProducts.displayName = 'HeaderBar.User.Products';
var _default = UserNavProducts;
exports["default"] = _default;